import { MissionCompletionData, SequenceMissionProps } from '../types/mission';
import { SequenceChallengeResult } from '../components/chess/SequenceChallenge';

const clampPercent = (value: number): number => Math.max(0, Math.min(100, Math.round(value)));

const roundTenths = (value: number): number => Math.max(0, Math.round(value * 10) / 10);

const roundWhole = (value: number): number => Math.max(0, Math.round(value));

export interface NormalizedMissionResults {
  score: number;
  accuracy: number;
  timeSpent: number;
  movesUsed?: number;
  hintsUsed?: number;
}

export const normalizeMissionResults = (
  results: Pick<MissionCompletionData, 'score' | 'accuracy' | 'timeSpent' | 'movesUsed' | 'hintsUsed'>
): NormalizedMissionResults => ({
  score: clampPercent(results.score),
  accuracy: roundTenths(results.accuracy),
  timeSpent: roundWhole(results.timeSpent),
  movesUsed: results.movesUsed !== undefined ? roundWhole(results.movesUsed) : undefined,
  hintsUsed: results.hintsUsed !== undefined ? roundWhole(results.hintsUsed) : undefined,
});

export interface NormalizedSequenceMissionResults {
  score: number;
  timeSpent: number;
  completedMoves: number;
  totalMoves: number;
  completionRate: number;
}

export const normalizeSequenceMissionResults = (
  result: Pick<SequenceChallengeResult, 'score' | 'timeSpent' | 'moves'>,
  mission: Pick<SequenceMissionProps, 'sequence'>
): NormalizedSequenceMissionResults => {
  const completedMoves = result.moves.length;
  const totalMoves = mission.sequence.length;

  return {
    score: clampPercent(result.score),
    timeSpent: roundWhole(result.timeSpent),
    completedMoves,
    totalMoves,
    completionRate: totalMoves > 0 ? Math.round((completedMoves / totalMoves) * 100) : 0,
  };
};
